import { render, staticRenderFns } from "./WholesaleAddIntroducerPage.vue?vue&type=template&id=d5b76646&scoped=true"
import script from "./WholesaleAddIntroducerPage.vue?vue&type=script&lang=js"
export * from "./WholesaleAddIntroducerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b76646",
  null
  
)

export default component.exports